import axiosIns from '@/libs/axios'
import i18n from '@/libs/i18n'
import { definitionId } from '@/libs/definitions'

const ROOT_URL = '/Admin/data/guides'
export default {
  namespaced: true,
  state: {
    loading: false,
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      id_licenses: null,
      title: null,
      description: null,
      task_type: null,
      status: 1,
      id_departments: null,
      id_teams: null,
      id_users: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    filterParams: {
      keywords: null,
      status: null,
      id_departments: null,
      id_teams: null,
    },
    createTaskGuideModal: {
      status: false,
      title: '',
      id_guides: null,
      id_projects: null,
      id_manager_users: null,
      id_departments: null,
      id_teams: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    filterParams(state) {
      return state.filterParams
    },

    createTaskGuideModal(state) {
      return state.createTaskGuideModal || {}
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    SET_CREATE_TASK_GUIDE(state, guide) {
      state.createTaskGuide = guide || null
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        id_licenses: null,
        title: null,
        description: null,
        task_type: null,
        status: 1,
        id_departments: null,
        id_teams: null,
        id_users: null,
      }
    },
    SET_CREATE_TASK_GUIDE_MODAL(state, data) {
      state.createTaskGuideModal = {
        status: true,
        title: data.title,
        id_guides: data.id,
        id_projects: data.id_projects,
        id_manager_users: data.id_manager_users,
        id_departments: data.id_departments,
        id_teams: data.id_teams,
      }
    },
    RESET_CREATE_TASK_GUIDE_MODEL(state) {
      state.createTaskGuideModal = {
        status: false,
        title: '',
        id_guides: null,
        id_projects: null,
        id_manager_users: null,
        id_departments: null,
        id_teams: null,
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_DATA_ITEM')
      commit('SET_DATA_LIST', [])
      const data = JSON.stringify(params || {})
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    async getDataItem({ commit }, id) {
      if (Number(id)) {
        commit('SET_LOADING', true)
        commit('RESET_DATA_ITEM')
        const requestData = {
          where: {
            'guides.id': id,
          },
          array: false,
        }
        return axiosIns
          .post(ROOT_URL, requestData)
          .then(response => {
            commit('SET_DATA_ITEM', response.data.data)
            commit('SET_LOADING', false)
            return response.data.data
          })
          .catch(error => console.error(error))
      }
      return false
    },
    saveData({ commit }, postData) {
      commit('SET_LOADING', true)
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    openCreateTaskModal({ commit }, guide) {
      commit('SET_CREATE_TASK_GUIDE', guide)
      commit('SET_CREATE_TASK_GUIDE_MODAL', guide)
    },
    closeCreateTaskModal({ commit }) {
      commit('RESET_CREATE_TASK_GUIDE_MODEL')
      commit('SET_CREATE_TASK_GUIDE', null)
    },
    removeData({ commit }, id) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data.status
        })
        .catch(error => console.error(error))
    },
    async createTaskFromGuide({ dispatch }, payload) {
      const {
        id_guides, title, id_projects, id_manager_users, id_departments, id_teams,
      } = payload
      // eslint-disable-next-line camelcase
      if (!id_guides || !title || !title.trim() || !id_departments || !id_teams) {
        throw new Error(i18n.t('errors.guides.required'))
      }
      const guide = await dispatch('getDataItem', id_guides)
      if (!guide) throw new Error(i18n.t('errors.guides.notFound'))
      // Alt görevleri id_guides üzerinden BE kopyalar (Tasks::getGuideSteps)
      const taskPayload = {
        title: title.trim(),
        description: guide.description || null,
        id_projects: id_projects || null,
        id_manager_users: id_manager_users || null,
        id_departments,
        id_teams,
        id_guides,
        id_task_priorities: definitionId('priority', 'medium'),
        id_task_statuses: definitionId('task', 'open'),
        watchers_can_update: 0,
      }
      const taskRes = await dispatch('tasks/saveData', taskPayload, { root: true })
      if (!taskRes?.status || !taskRes?.id) {
        throw new Error(taskRes?.message || i18n.t('errors.guides.taskFailed'))
      }
      return taskRes.id
    },
    async createSubtasksFromGuide({ dispatch }, { id_guides, id_tasks }) {
      if (!id_guides || !id_tasks) throw new Error(i18n.t('errors.guides.idsRequired'))
      const stepsRes = await axiosIns.post('/Admin/data/guide_steps', JSON.stringify({
        where: { 'guide_steps.id_guides': id_guides },
        select: ['guide_steps.title', 'guide_steps.description', 'guide_steps.ordering'],
        limit: 500,
        start: 0,
      }))
      const steps = stepsRes.data?.data || []
      for (let i = 0; i < steps.length; i += 1) {
        const step = steps[i]
        const res = await dispatch('subtasks/saveData', {
          id_tasks,
          title: step.title || '',
          description: step.description || null,
          ordering: step.ordering ?? i,
          id_subtask_statuses: definitionId('subtask', 'open'),
        }, { root: true })
        if (res?.status === false) throw new Error(res.message || i18n.t('errors.guides.subtaskFailed'))
      }
    },
  },
}
